module.exports = __webpack_public_path__ + "img/cockpit_blaupause.58df41b8.gif";